export default __webpack_public_path__ + "static/media/digital-signature.66cdd8b7.svg";